import {IonButton, IonSpinner} from '@ionic/react';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {signOut} from "../../reducers/authenticatedSlice";
import {AppDispatch} from "../../store";
import {useHistory} from "react-router";
import axios from "axios";
import {getToken} from "../../repositories/TokenRepository";

const AdminButton: React.FC = () => {
    const [isSuperAdmin, setIsSuperAdmin] = useState(null);
    const history = useHistory();

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/admin/isSuperAdmin`, {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        }).then(response => {
            setIsSuperAdmin(response.data.isSuperAdmin);
        })
    });
    
    if (isSuperAdmin === null) {
        return <IonButton disabled color="medium"><IonSpinner /></IonButton>
    }

    if (!isSuperAdmin) {
        return <></>
    }

    return <IonButton color="medium" onClick={async () => {
        history.push('/admin/users');
    }}>Admin dashboard</IonButton>;
};

export default AdminButton;
